<template>
  <v-container grid-list-xl id="home" class="full-height">
    <form-alert
      :type="alertText.type"
      :message="alertText.message"
      @close="closeFormAlert"
    ></form-alert>
    <v-content class="listar">
      <v-flex>
        <v-layout row wrap>
          <v-flex lg4 md6 sm12 xs12 v-for="(item, i) in items" :key="i">
            <v-card
              :class="
                item.routeName == 'Pendências'
                  ? `inative-route bg-${i}`
                  : `bg-${i}`
              "
            >
              <v-card-text>
                <button
                :id=" item.id " 
                  @click.prevent="handleRouteChanging(item)"
                  class="btn-primary jns-button mt-4 yellow-button"
                >
                  <div class="button-text-container">
                    <p>
                      <svg-icon>{{ item.icon }}</svg-icon
                      >{{ item.text }}
                    </p>
                  </div>
                </button>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-content>

    <v-dialog v-model="emBreveModal" :max-width="'640'">
      <base-modal>
        <h2 class="title" v-html="'Em Desenvolvimento'"></h2>
        <p class="description" v-html="'Em breve será disponibilizado.'"></p>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="emBreveModal = false"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <novas-demandas-component
      :showNovaDemandaDialog="showNovaDemandaDialog"
      @setShowNovaDemandaDialog="setShowNovaDemandaDialog()"
    />
  </v-container>
</template>

<script lang="js">

import ViewMixin from "@/mixins/ViewMixin";
export default {
  name: "Home",
  mixins: [ViewMixin],
  data: () => ({
    params: {},
    menu: null,
    emBreveModal: false,
    showNovaDemandaDialog: undefined,
    items: [
      {
        text: "Cadastrar/Consultar Tomador",
        icon: "menuTomador",
        routeName: "Consultar Tomadores",
        id: "home_card_cadastrar_tomador",
      },
      {
        text: "Incluir Proposta",
        icon: "incluirProposta",
        routeName: "Nova Proposta",
        id: "home_card_incluir_proposta",
      },
      {
        text: "Mesa de Trabalho",
        icon: "MesaDeTrabalho",
        routeName: "Mesa de Trabalho",
        id: "home_card_mesa_trabalho",
      },
      {
        text: "Extrato de Comissões e Produção da Corretora",
        icon: "menuCorretor",
        routeName: "Opções de Extratos",
        id: "home_card_extrato_comissao",
      },
      {
        text: "Endossos, Cancelamento e SAC",
        icon: "pendencias",
        action: "setShowNovaDemandaDialog",
        id: "home_card_endosso_cancelamento",
      },
      {
        text: "Meu Perfil e Cadastro de Usuários",
        icon: "meuPerfil",
        routeName: "Meu Perfil",
        id: "home_card_meu_perfil",
      },
    ],
  }),

  methods: {
    handleRouteChanging(item) {
      if (["Pendências"].includes(item.routeName)) {
        this.emBreveModal = true;
        return;
      }
      if (item.routeName) this.$router.push({ name: item.routeName });
      else this[item.action]();
    },

    setShowNovaDemandaDialog() {
      this.showNovaDemandaDialog = !this.showNovaDemandaDialog;
      this.$forceUpdate();
    }
  },

  mounted() {
    let t = this;
    this.hideLoadingIndicator();
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .v-card {
    padding: 0;
    height: 273px;
    background-size: cover;
    position: relative;
    &.bg-0 {
      background-image: url("~/static/img_01.jpg");
    }
    &.bg-1 {
      background-image: url("~/static/img_02.jpg");
    }
    &.bg-2 {
      background-image: url("~/static/img_03.jpg");
    }
    &.bg-3 {
      background-image: url("~/static/img_04.jpg");
    }
    &.bg-4 {
      background-image: url("~/static/img_05.jpg");
    }
    &.bg-5 {
      background-image: url("~/static/img_06.jpg");
    }
    button.jns-button {
      bottom: 45px;
      color: #061d45;
      font-weight: bold;
      position: absolute;
      width: calc(100% - 64px);
      left: 32px;

      .button-text-container {
        padding-left: 25px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-overflow: ellipsis !important;
        overflow: hidden !important;

        p {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis !important;
          overflow: hidden !important;
          margin: 0;
        }

        @media (max-width: 470px) {
          p {
            font-size: 0.875rem;
            padding: 0 5px;
          }
        }
      }
      &:hover /deep/ {
        color: white;
        path {
          fill: #fff;
        }
      }
      /deep/ svg {
        margin-left: -25px;
        position: absolute;

        path {
          margin-left: 0;
          color: #061d45;
        }
      }
    }
  }

  .v-sheet {
    height: 40vh !important;
  }
}

.inative-route {
  opacity: 0.5;
  pointer-events: none;
}

.container {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Home/Listar.vue